var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSyncBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5916 3.40816C14.6899 1.50649 11.9949 0.409828 9.03161 0.713161C4.74994 1.14483 1.22661 4.6215 0.748277 8.90316C0.10661 14.5615 4.48161 19.3332 9.99994 19.3332C13.7216 19.3332 16.9183 17.1515 18.4116 14.0132C18.7849 13.2315 18.2249 12.3332 17.3616 12.3332C16.9299 12.3332 16.5216 12.5665 16.3349 12.9515C15.0166 15.7865 11.8549 17.5832 8.40161 16.8132C5.81161 16.2415 3.72328 14.1298 3.17494 11.5398C2.19494 7.01316 5.63661 2.99983 9.99994 2.99983C11.9366 2.99983 13.6633 3.80483 14.9233 5.0765L13.1616 6.83816C12.4266 7.57316 12.9399 8.83316 13.9783 8.83316H18.1666C18.8083 8.83316 19.3333 8.30816 19.3333 7.6665V3.47816C19.3333 2.43983 18.0733 1.91483 17.3383 2.64983L16.5916 3.40816Z",
    fill: "#2196F3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncBlue);
export default __webpack_public_path__ + "static/media/sync-blue.e0915ba3175d4b26e5559581d15e6c8a.svg";
export { ForwardRef as ReactComponent };